import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { UpsellOption, getCheckoutUrl } from '../data/copy';
export function StickyCta({
  selectedUpsell
}: {
  selectedUpsell: UpsellOption;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 480);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-166" data-mp="3ueg93lw656jw">
      {visible && <motion.div initial={{
      y: 90
    }} animate={{
      y: 0
    }} exit={{
      y: 90
    }} transition={{
      duration: 0.3,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t-2 border-chartreuse/50 bg-abyss/95 px-4 py-3 backdrop-blur" data-id="element-167" data-mp="3gm0d351oq8sh">
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-4" data-id="element-168" data-mp="gyqzw3ylbq2l">
            <div className="min-w-0" data-id="element-169" data-mp="75cgsfb2uz4p">
              <p className="truncate font-cond text-base uppercase tracking-wide text-bone" data-id="element-170" data-mp="76fcr1n9brrh">
                {selectedUpsell.title} ·{' '}
                <span className="text-chartreuse" data-id="element-171" data-mp="gvp4gge6v8f2">${selectedUpsell.price} MXN</span>
              </p>
              <p className="truncate font-body text-xs text-ash" data-id="element-172" data-mp="c58oaoizh8p0">
                Lote limitado · garantía de 2 salidas
              </p>
            </div>
            <CtaButton size="md" source="barra-fija" href="#pack" itemName={selectedUpsell.title} value={selectedUpsell.price} className="shrink-0" data-id="element-173" data-mp="puslzfxpjfrg">
              Pescar más ya
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}